module.exports = __webpack_public_path__ + "media/grandfather.e4971a93.mp3";